"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NHSContractAdjustment_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var User_1 = require("./User");
var NHSContractAdjustment_Factory = /** @class */ (function () {
    function NHSContractAdjustment_Factory() {
    }
    NHSContractAdjustment_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AdjustmentAmount: model.AdjustmentAmount,
            AdjustmentDate: Date_Factory_1.Date_Factory.CreateIncoming(model.AdjustmentDate),
            ContractPeriodId: model.ContractPeriodId,
            IsUDA: model.IsUDA,
            Notes: model.Notes,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            User: User_1.User_Factory.CreateIncoming(model.User),
            UserId: model.UserId,
        };
        return result;
    };
    NHSContractAdjustment_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AdjustmentAmount: model.AdjustmentAmount,
            AdjustmentDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.AdjustmentDate),
            ContractPeriodId: model.ContractPeriodId,
            IsUDA: model.IsUDA,
            Notes: model.Notes,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            User: User_1.User_Factory.CreateOutgoing(model.User),
            UserId: model.UserId,
        };
        return result;
    };
    return NHSContractAdjustment_Factory;
}());
exports.NHSContractAdjustment_Factory = NHSContractAdjustment_Factory;
